import {createAsyncThunk} from '@reduxjs/toolkit'
import {
  FetchTypeRemarqueByIdRequest,
  UpdateTypeRemarqueRequest,
  FetchTypeRemarquesRequest,
  CreateTypeRemarqueRequest,
  DeleteTypeRemarqueRequest,
  SuspendTypeRemarqueRequest,
  ActivateTypeRemarqueRequest,
  FetchAllTypeRemarquesRequest
} from './types'
import {AxiosError} from 'axios'
import {ResponseError} from '../commonTypes'
import {TypeRemarque} from '../../../models'
import axios from 'axios'
import {
  fetchTypeRemarquesUrl,
  fetchTypeRemarqueByIdUrl,
  createTypeRemarqueUrl,
  updateTypeRemarqueUrl,
  deleteTypeRemarqueUrl,
  suspendTypeRemarqueUrl,
  activateTypeRemarqueUrl,
  fetchAllTypeRemarquesUrl
} from '../../api'

export const fetchTypeRemarques = createAsyncThunk(
  'typeRemarque/fetch',
  async (payload: FetchTypeRemarquesRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(
        `${fetchTypeRemarquesUrl}?sortField=${payload.sortField}&sortOrder=${
          payload.sortOrder
        }&pageNumber=${payload.pageNumber}&pageCount=${payload.pageCount}${
          payload.search && payload.search.trim() !== '' ? '&search=' + payload.search.trim() : ''
        }`
      )
      const {typeRemarques, totalPages, total} = res.data
      return {
        typeRemarques,
        totalPages,
        total,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const fetchAllTypeRemarques = createAsyncThunk(
  'typeRemarque/fetchAll',
  async (payload: FetchAllTypeRemarquesRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(
        `${fetchAllTypeRemarquesUrl}`
      )
      const {typeRemarques} = res.data
      return {
        typeRemarques,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const fetchTypeRemarqueById = createAsyncThunk(
  'typeRemarque/fetchById',
  async (payload: FetchTypeRemarqueByIdRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(`${fetchTypeRemarqueByIdUrl}/${payload.id}`)
      const {typeRemarque} = res.data
      return {
        typeRemarque,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const createTypeRemarque = createAsyncThunk(
  'typeRemarque/create',
  async (payload: CreateTypeRemarqueRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(createTypeRemarqueUrl, payload)
      const {typeRemarque} = res.data
      return {
        typeRemarque,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const updateTypeRemarque = createAsyncThunk(
  'typeRemarque/update',
  async (payload: UpdateTypeRemarqueRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(updateTypeRemarqueUrl, payload)
      const {typeRemarque} = res.data
      return {
        typeRemarque,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const deleteTypeRemarque = createAsyncThunk(
  'typeRemarque/delete',
  async (payload: DeleteTypeRemarqueRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(deleteTypeRemarqueUrl, payload)
      const {typeRemarque} = res.data
      return {
        typeRemarque,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const suspendTypeRemarque = createAsyncThunk(
  'typeRemarque/suspend',
  async (payload: SuspendTypeRemarqueRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(suspendTypeRemarqueUrl, payload)
      const {typeRemarque} = res.data
      return {
        typeRemarque,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const activateTypeRemarque = createAsyncThunk(
  'typeRemarque/activate',
  async (payload: ActivateTypeRemarqueRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(activateTypeRemarqueUrl, payload)
      const {typeRemarque} = res.data
      return {
        typeRemarque,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)
